import { Stack, Container, Typography } from '@mui/material';

import RedeemTableView from 'src/sections/management/user/tabs/redeem/redeem-view';

export default function RedeemView() {
  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4" gutterBottom>
          ถอนสินค้า
        </Typography>
        <RedeemTableView enableCreate isCreateAndApprove />
      </Stack>
    </Container>
  );
}
